import { builtinV1 } from '../../builtin'

// klinecharts 9.8.12 built-in 'VR' (dist/index.esm.js), untouched: version 1 for existing instances only.
export default builtinV1({ id: 'VR', label: 'Volume Ratio', pane: 'sub', params: [26, 6], outputs: ['vr', 'maVr'] })
